import { render, staticRenderFns } from "./MessageDetailsModal.vue?vue&type=template&id=1b46c4e5&scoped=true"
import script from "./MessageDetailsModal.vue?vue&type=script&lang=js"
export * from "./MessageDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailsModal.vue?vue&type=style&index=0&id=1b46c4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46c4e5",
  null
  
)

export default component.exports